import { GetterTree } from 'vuex'
import { BlacklistsState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<BlacklistsState, RootState> = {
    blacklists:state => state.blacklists,
    blacklistContacts:state => state.blacklistContacts,
    blacklistItem:state => state.blacklistItem,
};
